/*
 * Copyright (c) 2022 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, { useState } from "react";
import FCDIYGatewaySearchResult from "./FCDIYGatewaySearchResult";
import { Button, Progress, Search } from "@scuf/common";
import "../../wizard/GatewayRegistration/SiteSelection.scss";
import { IGatewayDetails } from "./IGatewayDetails";
import { IGatewayDetail } from "./IGatewayDetails";
import ConfirmGatewaySelection from "../../wizard/GatewayRegistration/ConfirmGatewaySelection";
import { IGatewayRegistration } from "../../../stores/GatewayManager/IGatewayRegistrationInterfaces";
/**
 *  The user interface component for gateway selection
 */
const FCDIYGatewayRegistration = (props: IGatewayDetails) => {
  const [searchString, setSearchString] = useState("");
  const [radioSelected, setRadioSelected] = useState("");
  const [confirmationRender, setConfirmationRender] = useState(false);
  const [gatewayselected, setGatewaySelected] = useState(new IGatewayDetail());
  const project: string = ((props.userInfo.custom && props.userInfo.custom.tenant) ? props.userInfo.custom.tenant:null) as string;

  const registerGatewayOnClick = () => {
    const gatewayRegistration: IGatewayRegistration = {
      sitesLoaded: true,
      selectedGateway: {
        gatewayName: gatewayselected.gatewayName,
        tenant: project,
        serialNumber: props.appliance.serialNumber,
        enrollmentIdentity: props.appliance.enrollmentId,
        originalEp: props.appliance.originalEndpoint,
        projectId: project,
        gatewayId: gatewayselected.fcGatewayExternalId,
      },
      errors: {},
      renderView: false,
    };
    return (
      <ConfirmGatewaySelection
        gatewayDetails = {props}
        gatewayRegistration={gatewayRegistration}
        cancelHandler={() => setConfirmationRender(false)}
      />
    );
  };

  const gatewaySearchResults = () => {
    const filteredList: IGatewayDetail[] = props.details
                  .filter((gateway: IGatewayDetail) =>
                    gateway.gatewayName.includes(searchString)
                  );
    return (
      <React.Fragment>
        <div className="application-page-content ui-site-selection-container">
          <div>
            {titleInfo(project)}
            <div className="ui-search">
              <Search
                results={[]}
                noResultsMessage={"\t"}
                placeholder="Search for building or address"
                onSearchChange={(value: string = "") => setSearchString(value)}
              />
            </div>
            {props.details.length == 0 ? (
              <div className="ui-sites-loading">
                <Progress circular={true} size={"xlarge"} />
              </div>
            ) : (
              <div className="ui-site-list">
                {
                filteredList.map((gateway: IGatewayDetail) => {
                    return (
                      <FCDIYGatewaySearchResult
                        key={gateway.fcGatewayExternalId}
                        gatewayName={gateway.gatewayName}
                        externalId={gateway.externalId}
                        fcGatewayExternalId = {gateway.fcGatewayExternalId}
                        gatewayStatus={gateway.gatewayStatus}
                        gatewayType={gateway.gatewayType}
                        serialNumber={gateway.serialNumber}
                        softwareInfo={gateway.softwareInfo}
                        onSelectCall={() => {
                          setRadioSelected(gateway.fcGatewayExternalId);
                          setGatewaySelected(gateway);
                        }}
                        selected={gateway.fcGatewayExternalId == radioSelected}
                      ></FCDIYGatewaySearchResult>
                    );
                  })}
              </div>
            )}
          </div>
        </div>

        <div className="application-navigation ui-box-shadow">
          <div className="ui-site-selection-navigation">
            <Button
              type="primary"
              className="register-gateway-btn"
              disabled={radioSelected === ""}
              content={`${REGISTER_GATEWAY}`}
              onClick={() => setConfirmationRender(true)}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {confirmationRender ? registerGatewayOnClick() : gatewaySearchResults()}
    </React.Fragment>
  );
};

const titleInfo = (customer: any) => {
  return (
    <React.Fragment>
      <div className="ui-site-selection-title">{TITLE}</div>
      <div className="ui-site-selection-message">{SUB_TITLE_1}</div>
      <div className="ui-site-selection-message">{title2(customer)}</div>
    </React.Fragment>
  );
};

const title2 = (customer: any) => {
  return (
    "Please select the Appliance Gateway you wish to register " +
    customer +
    " with"
  );
};

const TITLE: string = "Select Application Gateway";
const SUB_TITLE_1: string =
  "We found the following gateways associated with your Honeywell Forge account.";

const REGISTER_GATEWAY: string = "Register Gateway";

export default FCDIYGatewayRegistration;
